import useIsMounted from 'ismounted';
import { useEffect } from 'react';
import { useStore } from 'store';
import { delay } from 'utils/delay';

function useCheckUserConnection() {
  const [isUserInternetOnline, setIsUserInternetOnline] = useStore((state) => [
    state.isUserInternetOnline,
    state.setIsUserInternetOnline,
  ]);

  const isMounted = useIsMounted();

  const validateConnection = async () => {
    await Promise.any([
      fetch('https://client3.google.com/generate_204', {
        method: 'HEAD',
        cache: 'no-cache',
        mode: 'no-cors',
      }),
      fetch(`${import.meta.env.VITE_PLUTO_API_ENDPOINT}/health-check`, {
        method: 'HEAD',
        cache: 'no-cache',
      }),
    ])
      .then(() => {
        if (!isUserInternetOnline) setIsUserInternetOnline(true);
      })
      .catch(() => {
        if (isUserInternetOnline) setIsUserInternetOnline(false);
      });
  };

  useEffect(() => {
    (async () => {
      while (isMounted.current) {
        await delay(8000);
        await validateConnection();
      }
    })();
  }, []);
}
export default useCheckUserConnection;
